export default __webpack_public_path__ + "assets/pdf/FT_VG37.0b890be3.pdf";